import React, { useState } from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import { useOperatorAuth } from '@contexts/operator/OperatorAuthContext';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import { useTranslation } from 'react-i18next';

import FormContent from './Form';

interface OperatorWarehouse {
  id?: string;
  title?: string;
}

const OperatorPickingListPresetNew: React.FC = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  return (
    <div className="page-content">
      <MerchantSelect
        title={t('operator.picking_list_presets.merchant_selection_title')}
        subtitle={t('operator.picking_list_presets.merchant_selection_subtitle')}
      >
        <NewFormContent loading={loading} setLoading={setLoading} />
      </MerchantSelect>
    </div>
  );
};

// 拆成 inner component 是因為 MerchantSelect 必須先讓使用者選 merchant，選完後 context
// 才有 merchant / merchant-scoped reference data 可以注入 Form。把 useOperatorData 放到
// 外層會在 merchant 未選時就讀到空清單。
const NewFormContent: React.FC<{ loading: boolean; setLoading: (v: boolean) => void }> = ({
  loading,
  setLoading,
}) => {
  const { merchant, merchantShippingTypes = [], merchantSalesChannels = [] } = useOperatorData();
  const { operator } = useOperatorAuth();
  const operatorWarehouseId = (operator?.warehouse as OperatorWarehouse | undefined)?.id ?? null;

  // <MerchantSelect> 已在外層 gate；本元件 mount 時 merchant 必存在。TS narrow。
  if (!merchant?.id) return null;

  return (
    <FormContent
      loading={loading}
      setLoading={setLoading}
      salesChannels={merchantSalesChannels}
      shippingTypes={merchantShippingTypes}
      merchantIdForCreate={merchant.id}
      warehouseIdForCreate={operatorWarehouseId}
    />
  );
};

export default OperatorPickingListPresetNew;
